import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.whiteish,
  fontColor: colors.graphite,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default promoBanner;